import { useEffect, useRef } from "react";
import DatenschutzNotice from "@/components/legal/DatenschutzNotice";
import {
  legalNoticePlaceholderParagraphs,
  legalNotices,
  type LegalNoticeId,
} from "@/components/legal/legalNotices";

interface LegalNoticePageProps {
  notice: LegalNoticeId;
}

/**
 * Datenschutz or Impressum — a public page linked from the header.
 */
const renderNoticeBody = (notice: LegalNoticeId) => {
  if (notice === "datenschutz") {
    return <DatenschutzNotice />;
  }

  return legalNoticePlaceholderParagraphs.map((paragraph) => (
    <p key={paragraph}>{paragraph}</p>
  ));
};

export const LegalNoticePage = ({ notice }: LegalNoticePageProps) => {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const { pageTitle } = legalNotices[notice];

  const focusLegalNoticeHeading = () => {
    headingRef.current?.focus();
  };

  useEffect(focusLegalNoticeHeading, [notice]);

  return (
    <article className="px-4 py-8 md:px-8">
      <h1
        ref={headingRef}
        tabIndex={-1}
        className="mb-6 max-w-3xl text-h1 text-primary outline-none"
      >
        {pageTitle}
      </h1>
      <div className="prose max-w-3xl">{renderNoticeBody(notice)}</div>
    </article>
  );
};
